import React from "react";
import { Table } from "antd";
import SecondaryButton from "../../../Button/SecondaryButton";
import { Puff } from "react-loader-spinner";
import {
  CheckCircleIcon,
  ClockIcon,
  TruckIcon,
  XCircleIcon,
} from "lucide-react";

interface OrderSummaryProps {
  editingOrder: {
    quote_status: string;
    reference_number: string;
    requested_ship_date: string;
    latest_status: string;

    products: any[];
  } | null;
  loading: boolean;
  values: ParcelItem[];
  recentOrderStatus: {
    eventdescription: string;
  } | null;
  status?: string;
  setValues: (value: ParcelItem[]) => void;
  handleViewLabelsClick: (value: any) => void;
  createLogistics?: () => void;
}

export interface ParcelItem {
  key: React.Key;
  parcelNo: number;
  items: number;
  height: number;
  width: number;
  length: number;
  weight: number;
}

const Loader: React.FC = () => {
  return (
    <div className="flex items-left justify-left ">
      <Puff
        visible={true}
        height="60"
        width="60"
        color="#75A7AD"
        ariaLabel="puff-loading"
      />
    </div>
  );
};
const OrderStatus: React.FC<OrderSummaryProps> = ({
  editingOrder,
  loading,
  createLogistics,
}) => {
  const productColumn = [
    {
      title: "Parcel #",
      dataIndex: "parcel_number",
      key: "parcel_number",
      render: (_: any, __: any, index: number) => index + 1,
    },

    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Height",
      dataIndex: "height",
      key: "height",
    },
    {
      title: "Weight",
      dataIndex: "weight",
      key: "weight",
    },
    {
      title: "Width",
      dataIndex: "width",
      key: "width",
    },
    {
      title: "Length",
      dataIndex: "length",
      key: "length",
    },
  ];

  const getStatusIcon = (eventDescription: string) => {
    switch (eventDescription) {
      case "order_received":
      case "Order Packed":
        return <ClockIcon className="h-6 w-6 text-[#75A7AD]" />;
      case "Out of Delivery":
        return <TruckIcon className="h-6 w-6 text-blue-500" />;
      case "Collected by Courier":
      case "In Transit":
        return <CheckCircleIcon className="h-6 w-6 text-green-500" />;
      case "Delivered":
        return <XCircleIcon className="h-6 w-6 text-red-500" />;
      default:
        return null;
    }
  };
  const getQuoteStatusIcon = (quote_status: string) => {
    switch (quote_status) {
      case "failed":
        return <XCircleIcon className="h-6 w-6 text-red-700" />;
      case "accepted":
        return <CheckCircleIcon className="h-6 w-6 text-[#75A7AD]" />;
      default:
        return null;
    }
  };
  

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = {
      weekday: "long",
      day: "numeric",
      year: "numeric",
      month: "long",
    };
    return new Intl.DateTimeFormat("en-US", options).format(date);
  };

  return (
    <div>
      <h3 className="text-lg font-medium">
        ORDER NUMBER : {editingOrder?.reference_number}
      </h3>
      <div className="flex w-full bg-white justify-between gap-x-4">
        <div className="w-1/2  flex  bg-white  rounded-lg mb-4 ">
          {editingOrder && (
            <div className=" bg-white  w-full  rounded-lg ">
              <ul className="space-y-4  w-full">
                <li className="flex items-center justify-between p-1 border w-full">
                  <div className="flex items-center space-x-2">
                    <div>{getQuoteStatusIcon(editingOrder.quote_status)}</div>

                    <div>
                      <p className="text-[rgb(0,93,110)] text-[20px] mb-[15px] font semi-bold">
                        Quote Status
                      </p>

                      <div>
                        <p className="text-gray-600 capitalize">{`Status: ${editingOrder?.quote_status}`}</p>
                      </div>
                      {editingOrder && (
                        <div className="text-sm text-gray-500">
                          {formatDate(editingOrder.requested_ship_date)}
                        </div>
                      )}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          )}
        </div>

        <div className="w-1/2  flex  bg-white  rounded-lg mb-4 ">
          {editingOrder && (
            <div className=" bg-white  w-full  rounded-lg ">
              <ul className="space-y-4  w-full">
                <li className="flex items-center justify-between p-1 border w-full">
                  <div className="flex items-center space-x-2">
                    <div>{getStatusIcon(editingOrder.quote_status)}</div>

                    <div>
                      <p className="text-[rgb(0,93,110)] text-[20px] mb-[15px] font semi-bold">
                        Order Status
                      </p>

                      <div>
                        <p className="text-gray-600 capitalize">{`Status: ${
                          editingOrder?.latest_status || ""
                        }`}</p>
                      </div>
                      {editingOrder && (
                        <div className="text-sm text-gray-500">
                          {formatDate(editingOrder.requested_ship_date)}
                        </div>
                      )}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>

      <Table
        columns={productColumn}
        dataSource={editingOrder?.products}
        className="custom-table"
        rowClassName={(record, index) =>
          index % 2 === 0 ? "table-row-even" : "table-row-odd"
        }
        pagination={false}
      />

      {editingOrder?.quote_status !== "accepted" && (
        <div className="mt-5">
          {loading ? (
            <Loader />
          ) : (
            <SecondaryButton label={"Accept Quote"} onClick={createLogistics} />
          )}
        </div>
      )}
    </div>
  );
};

export default OrderStatus;
